import { trace } from 'firebase/performance';

import { firebasePerformance } from './firebase';

export const startTrace = (traceName: string) => {
  if (firebasePerformance) {
    return trace(firebasePerformance, traceName);
  }
  return null;
};

export const measurePageLoad = (pageName: string) => {
  const pageTrace = startTrace(`page_load_${pageName}`);
  if (pageTrace) {
    pageTrace.start();
    return () => pageTrace.stop();
  }
  return () => {};
};

export const measureApiCall = (endpoint: string) => {
  const apiTrace = startTrace(`api_call_${endpoint}`);
  if (apiTrace) {
    apiTrace.start();
    return () => apiTrace.stop();
  }
  return () => {};
};

export const measureUserAction = (actionName: string) => {
  const actionTrace = startTrace(`user_action_${actionName}`);
  if (actionTrace) {
    actionTrace.start();
    return () => actionTrace.stop();
  }
  return () => {};
};

export const measureChallengeLoad = (challengeId: string) => {
  const challengeTrace = startTrace(`challenge_load_${challengeId}`);
  if (challengeTrace) {
    challengeTrace.start();
    return () => challengeTrace.stop();
  }
  return () => {};
};

export const measureTradeExecution = (coinId: string) => {
  const tradeTrace = startTrace(`trade_execution_${coinId}`);
  if (tradeTrace) {
    tradeTrace.start();
    return () => tradeTrace.stop();
  }
  return () => {};
};

export const measureDataFetch = (dataType: string) => {
  const fetchTrace = startTrace(`data_fetch_${dataType}`);
  if (fetchTrace) {
    fetchTrace.start();
    return () => fetchTrace.stop();
  }
  return () => {};
};
